var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Grafica "+_vm._s(_vm.id)+" rhb")]),_vm._v(" "),_c('v-btn',{staticClass:"ma-2 btnBuscar elevation-2",attrs:{"tile":"","outlined":"","color":"indigo"},on:{"click":function($event){return _vm.verGrafica2()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-magnify")]),_vm._v(" ver Grafica "+_vm._s(_vm.id)+"\n\t")],1),_vm._v(" "),_c('router-view',{staticClass:"nested-child"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de931066","hasScoped":true,"buble":{"transforms":{}}}!./src/components/Gestion/gestionRehabilitacion/graficaRhb/graficaRhb.html
// module id = 1091
// module chunks = 0